<template>
  <a
    href="https://share.hsforms.com/19kcDaALnRUuT2y9J7SGGzg3prjk"
    target="_blank"
    :class="[
      'feedback',
      {
        feedback__collapsed: collapsed,
      },
    ]"
  >
    <icon
      data="@icon/loudspeaker.svg"
      width="2em"
      height="2em"
      class="icon"
      original
      :stop-colors="['#FFFA1E', '#FFA400', '#F346F7']"
    />
    <p class="p-m-0" v-if="!collapsed">Help us enhance GenTwo Pro with your input.</p>
    <i v-if="!collapsed" class="pi pi-arrow-right"></i>
  </a>
</template>
<script setup lang="ts">
defineProps<{
  collapsed: boolean;
}>();
</script>
<style lang="scss" scoped>
.feedback {
  display: flex;
  align-items: center;
  margin-bottom: 1.34rem;
  padding: 1.34rem 1rem;
  gap: 0.67rem;
  background: var(--nav-menu-active-bg-color);
  font-size: 1rem;
  transition: all 0.2s ease-in-out;
  box-shadow: 0px 6px 15px 20px var(--nav-menu-bg-color);
  i {
    color: var(--secondary-color-text-neutral-darker);
  }
  &__collapsed {
    padding: 16px 7px;
    justify-content: center;
  }
  &:hover {
    opacity: 0.85;
  }
}
</style>
